import { isFullScreen } from '../../user/device-info';

function onFullscreenChange( ctx ) {
    ctx.isFullScreen = isFullScreen();
}

export {
    onFullscreenChange,
};
